
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterModule,Router, NavigationEnd, } from '@angular/router';
import { filter } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CanonicalService } from '../../shared/seo/canonical.service';


@Component({
  selector: 'app-home',
  imports: [RouterModule,CommonModule,FormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
   encapsulation: ViewEncapsulation.None 
})
export class HomeComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta,private router: Router,private canonicalService: CanonicalService) { }

  activeTab: 'development' | 'consulting' | 'solutions' | 'marketing' = 'development';

  setActiveTab(tab: 'development' | 'consulting' | 'solutions' | 'marketing') {
    this.activeTab = tab;
  }

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('MALtech | Software Development & Innovative IT Solutions');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content: 'MALtech specializes in product engineering, SEO, IT services, digital marketing, transactional emails, and email validation.'
    });

    // Optional: Add other meta tags
    this.metaService.updateTag({ name: 'keywords', content: 'IT services, UX Design, User Experience, Web Design, UI' });
    this.metaService.updateTag({ name: 'author', content: 'Maltech' });

    this.canonicalService.setCanonicalURL('');
  }

  
  scrollToSectionByClass(section : string) {
    const elements = document.getElementsByClassName(section);

    if (elements.length > 0) {
      const element = elements[0] as HTMLElement; // Ensure correct type

      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const headerHeight = 100;
      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: 'smooth'
      });
    }
  }
  Career() {
    const plansSection = document.getElementById('consulting-tab-pane');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

chooseUsCards = [
  {
    title: 'SaaS & Cloud Expertise',
    text: 'We deliver scalable, secure, and cloud-native solutions trusted by enterprises worldwide, built for reliability, flexibility, and future growth.',
    img: 'assets/images/home/why-choose-us/316/herosection2.webp',
    imgSrcset: 'assets/images/home/why-choose-us/316/herosection2.webp 316w, assets/images/home/why-choose-us/632/herosection2.webp 632w'
  },
  {
    title: 'End-to-End Delivery',
    text: 'From consultation to full-scale development, we deliver end-to-end tech solutions that drive innovation, efficiency, and long-term success.',
    img: 'assets/images/home/why-choose-us/316/herosection3.webp',
    imgSrcset: 'assets/images/home/why-choose-us/316/herosection3.webp 316w, assets/images/home/why-choose-us/632/herosection3.webp 632w'
  },
  {
    title: 'Focus on Quality and Security',
    text: 'We build reliable, secure, and fast solutions that consistently empower organizations, consistent performance, and business excellence.',
    img: 'assets/images/home/why-choose-us/316/hero-section.webp',
    imgSrcset: 'assets/images/home/why-choose-us/316/hero-section.webp 316w, assets/images/home/why-choose-us/632/hero-section.webp 632w'
  }
];

}
